import React from 'react';
import i18next from 'i18next';
import DateService from '../../../../../services/dateService';
import CommonService from '../../../../../services/commonService';
import getIcons from '../../../functions/getIcons/getIcons';

function BusBodyItem(props) {
  console.log('BusBodyItem', props);
  return (
    <div key={props.keyValue}>
      <div>
        {props.val.heading && (
          <div className="my-trips-title">
            <span>{props.val.heading}</span>
          </div>
        )}

        <div className="kupos-card my-trips-item font9">
          <div className="display-flex">
            <div>
              <div className="my-trips-sub-item less-bold-text font11">
                {props.val.origin_name + ' - ' + props.val.destination_name}
              </div>
              <span className="individual-line font9">
                {DateService.changeDateFormat(
                  props.val.departure_datetime.split(' ')[0],
                  'yyyy-mm-dd',
                  'dd/mm/yyyy',
                )}
              </span>
              <br />
              <span className="individual-line font9">
                {props.t('PROFILE.STATUS')}:{' '}
                {props.val.status_label === 'Confirmado'
                  ? props.t('STATUS.CONFIRMED')
                  : props.val.status_label === 'Cancelado'
                  ? props.t('STATUS.CANCELLED')
                  : props.val.status_label}
              </span>
            </div>

            <div className="right-section-trips-item">
              <div className="float-right">
                <div
                  className=" less-bold-text see-more-trip-details"
                  onClick={() => props.onSeeMoreClickedBus(props.val, props.keyValue)}
                  style={{
                    color:
                      props.operator &&
                      props.operator.color_codes &&
                      props.operator.color_codes.account_text_color
                        ? props.operator.color_codes.account_text_color
                        : '',
                  }}
                >
                  {props.t('PROFILE.VIEW_MORE')}
                  <span className="sub-section-my-trips-strip-arrow-icon">
                    {props.operator ? (
                      <img
                        src={getIcons('downArrow', props.operator)}
                        alt=""
                        style={{ height: '1vw' }}
                      />
                    ) : (
                      <img src="/static/images/icons/home/icon_arrow_down.png" alt="" />
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          'sub-body-my-trips font10 ' +
          'light-grey-text ' +
          (props.keyValue == props.selectedTripItem ? 'show' : 'hide')
        }
      >
        {!props.busTicketLoading && props.ticketDetailsBus ? (
          <div>
            <span className="sub-body-my-trips-title primary-text-color bold-text font10">
              {props.t('PROFILE.TRIP_DETAIL')}
            </span>
            <div className="sub-body-sub-item ">
              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRAVEL_DATE')}</span> <br />
                  <span className="font10">{props.ticketDetailsBus.travel_date}</span>
                </div>
              </div>

              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRAVEL_TIME')}</span> <br />
                  <span className="font10">
                    {DateService.ampm(props.ticketDetailsBus.depart_time)}
                  </span>
                </div>
              </div>

              <div>
                <div>
                  <span className="bold-text font10">{props.t('PROFILE.TRANSACTION_NUMBER')}</span>{' '}
                  <br />
                  <span className="font10">{props.ticketDetailsBus.pnr_number}</span>
                </div>
                <div>
                  {/* <span className="bold-text font10">{props.t('CHANGE_TICKET.CODE')}</span> <br />
                  <span className="font10">
                    {
                      props.ticketDetailsBus.seat_Details.seat_details[
                        `${props.ticketDetailsBus.seat_nos}`
                      ].travel_operator_pnr
                    }
                  </span> */}
                </div>
              </div>
            </div>
            <hr className="horizontal-line" />
            <div>
              <span className="bold-text font10">{props.t('PROFILE.DEPARTURE_POINT')}</span>
              <ul className="sub-item-list font10">
                <li>
                  {props.ticketDetailsBus.boarding_details.address} -{' '}
                  {DateService.ampm(props.ticketDetailsBus.boarding_details.time)}
                </li>
              </ul>
              <span className="bold-text font10">{props.t('PROFILE.ARRIVAL_POINT')}</span>
              <ul className="sub-item-list font10">
                <li>
                  {props.ticketDetailsBus.arrival_details.address} -{' '}
                  {DateService.ampm(props.ticketDetailsBus.arrival_details.time)}
                </li>
              </ul>

              <div className="sub-body-sub-item">
                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.COMPANY')}: {props.ticketDetailsBus.operator_service_name}
                    </span>
                  </div>
                </div>

                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.SEATS')}: {props.ticketDetailsBus.seat_nos}
                    </span>
                  </div>
                </div>

                <div>
                  <div>
                    <span className="font10">
                      {props.t('PROFILE.TOTAL_PRICE')}:{' '}
                      {CommonService.currency(props.ticketDetailsBus.total_booked_amount)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr className="horizontal-line" />
            <div className="sub-body-sub-item">
              <div>
                <div>
                  <span className="bold-text font10">
                    {/* {props.t('PROFILE.QUALIFICATION')} */}
                    {props.t('PROFILE.STATUS')}
                  </span>{' '}
                  <br />
                  <span className="font10">
                    {props.ticketDetailsBus.status_label === 'Confirmado'
                      ? props.t('STATUS.CONFIRMED')
                      : props.ticketDetailsBus.status_label === 'Cancelado'
                      ? props.t('STATUS.CANCELLED')
                      : props.ticketDetailsBus.status_label}
                  </span>
                </div>
              </div>

              <div>
                {props.ticketDetailsBus &&
                (props.ticketDetailsBus.status.toUpperCase() != 'CANCELADO' ||
                  props.ticketDetailsBus.status.toUpperCase() == 'PARTIAL CANCELADO') &&
                props.notIspast(
                  DateService.changeDateFormat(
                    props.ticketDetailsBus.travel_date,
                    'dd/mm/yyyy',
                    'yyyy-mm-dd',
                  ),
                ) ? (
                  <div className="d-flex">
                    <div className="cancelation-conformation-box mr-2">
                      <button
                        className="kupos-button font10"
                        onClick={() => window.open(props.ticketDetailsBus.print_pdf_url)}
                        style={{
                          background:
                            props &&
                            props.operator &&
                            props.operator.color_codes &&
                            props.operator.color_codes.button_color,
                          color: 'white',
                        }}
                      >
                        {props.busTicketCancellationLoading ? (
                          <div className="loader-cricle"></div>
                        ) : (
                          <span>
                            {i18next.language == 'es'
                              ? 'Descarga tu pasaje'
                              : 'Download your proof'}
                          </span>
                        )}
                      </button>
                    </div>
                    <div className="cancelation-conformation-box">
                      <button
                        className="kupos-button font10"
                        onClick={() => {
                          localStorage.setItem('isChangeTicket', false);
                          props.cancelBusTicket(props.ticketDetailsBus, 'bus');
                        }}
                        style={{
                          background:
                            props &&
                            props.operator &&
                            props.operator.color_codes &&
                            props.operator.color_codes.button_color,
                          color: 'white',
                        }}
                      >
                        {props.busTicketCancellationLoading ? (
                          <div className="loader-cricle"></div>
                        ) : (
                          <span>{props.t('PROFILE.CANCEL_TRIP')}</span>
                        )}
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <div className="loading-bus-ticket-details">{props.t('CANCEL_TICKET.LOADING')}</div>
        )}
      </div>
    </div>
  );
}

export default BusBodyItem;



// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyTrips/components/BusBodyItem.js